import React, {ChangeEvent, useEffect, useState} from "react";
import { findSubSegmentProps, findSegmentProps } from "../../../../../utils/types";
import { api, getToken } from "../../../../../services/apis/auth-api/apiUrl";
import * as end_point from "../../../../../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTimes, faTrashAlt, faWarning, faSpinner } from "@fortawesome/free-solid-svg-icons";
import CheckButton from "../../../buttons/manage-jdl/globalCheckButton";
import { toEditSubSegProps, subSegError } from "../../../../../utils/types";

const SubSegments : React.FC<findSegmentProps> = ({id, segment_name}) =>{

    const [subSegments, setSubSegments] = useState<findSubSegmentProps[]>([]);
    const [toEditStr, setToEditStr] = useState<toEditSubSegProps[]>([]);

    const updateToeditStr = (id : number, e : ChangeEvent<HTMLInputElement>) => {
        const updatedStr = toEditStr.map((item : toEditSubSegProps) =>
            item.id === id ? {...item, sub_segment_name : e.target.value } : item)

        setToEditStr(updatedStr);
    }

    const setEditing = (sub_id : number) =>{
        const toEdit = subSegments.map((item: findSubSegmentProps) => 
            item.id === sub_id ? {...item, editing: true} : item)

        setSubSegments(toEdit);
    }

    const cancelEditing = (sub_id : number) =>{
        const cancel = subSegments.map((item: findSubSegmentProps) => 
            item.id === sub_id ? {...item, editing: false} : item)
        setSubSegments(cancel);
    }

    const setToDelete = (sub_id : number) =>{
        const toEdit = subSegments.map((item: findSubSegmentProps) => 
            item.id === sub_id ? {...item, to_delete: true} : item)
        setSubSegments(toEdit);
    }

    const cancelToDelete = (sub_id : number) =>{
        const cancel = subSegments.map((item: findSubSegmentProps) => 
            item.id === sub_id ? {...item, to_delete: false} : item)
        setSubSegments(cancel);
    }

    const setLoading = (id : number, loadRes : boolean) => {
        const isLoad = subSegments.map((item : findSubSegmentProps)=>
            item.id === id ? {...item, isLoading : loadRes} : item
        )
        setSubSegments(isLoad);
    }

    const setError = (id : number, error : subSegError) => {
        const errorStat = subSegments.map((item : findSubSegmentProps)=>
            item.id === id ? {...item, submitError : error} : item
        )
        setSubSegments(errorStat);
    }

    const setUpdated = (id : number, name : string, method : string) =>{
        let updated;
        if(method === 'put'){
            updated = subSegments.map((item : findSubSegmentProps)=>
                item.id === id ? {
                    ...item, 
                    sub_segment_name : name,
                    editing : false
                } : item
            )
        }else{
            updated = subSegments.filter((item : findSubSegmentProps)=>
               item.id !== id
            )
        }
        setSubSegments(updated);
    }

    useEffect(()=>{
        async function getSubSegments() {
            try{
                const sub_segments = await api.get(end_point.GET_SUB_SEGMENTS_END_POINT+id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setToEditStr(sub_segments.data);
                const data = sub_segments.data;
                setSubSegments(data.map((item: findSubSegmentProps) => ({
                    ...item,
                    editing: false, 
                    to_delete : false,
                    isLoading : false,
                    submitError : {error : false, msg : ''}
                })));
            }catch(e){}
        }
        getSubSegments();
    },[id]);

    return (
        <div className="min-w-96">
            <div className="uppercase">
                {segment_name}/Sub-Segments
            </div>
            <div className="items-center hidden">
                <div className="ms-auto input-container">
                    <input type="text" placeholder="Search sub-segments..." className="text-box max-w-56" />
                </div>
            </div>
            <div className="max-h-96 min-w-tbl overflow-y-auto overflow-x-auto hide-scrollbar bg-white w-full p-2">
                <table className="w-full border">
                    <thead className="table-fixed-header border">
                        <tr>
                            <th className='table-headers'>#</th>
                            <th className='table-headers'>Sub-Segment Name</th>
                            <th className='table-headers'>Action</th>
                        </tr>
                    </thead>
                    {subSegments.length > 0 ? (
                        <tbody className="text-center">
                            {subSegments.map((value, index) => (
                                <tr className="hover:bg-gray-300">
                                    <td className='table-body px-2'>{index + 1}</td>
                                    {value.editing && (
                                        <>
                                            <td className='relative table-body px-1'>
                                                {toEditStr.map((str)=> str.id === value.id && (
                                                    <>
                                                        <p className={value.submitError.error ? 'err-row-msg' : 'hidden'}>
                                                            {value.submitError.msg}
                                                        </p>
                                                        <input type="text" className='text-box w-full text-center'
                                                            value={str.sub_segment_name}
                                                            onChange={(e)=>updateToeditStr(str.id, e)}
                                                        />
                                                    </>
                                                ))}
                                            </td>
                                            <td className='table-body px-2'>
                                                {value.isLoading && (
                                                    <div>
                                                        <FontAwesomeIcon className="animate-spin text-xl text-blue-500" icon={faSpinner} />
                                                    </div>
                                                )}
                                                {!value.isLoading &&(
                                                    <div className='flex gap-4 justify-center text-2xl items-center'>
                                                        <CheckButton 
                                                            id={value.id} 
                                                            onLoad={(id, loadres)=> setLoading(id, loadres)}
                                                            toUpdate={toEditStr}
                                                            endPoint={end_point.UPDATE_SUB_SEGMENT_NAME_END_POINT}
                                                            method="put"
                                                            onSubmitStat={(id , error) => setError(id, error)}
                                                            onUpdated={(id, name) => setUpdated(id, name, 'put')}
                                                        />
                                                        <i onClick={()=>cancelEditing(value.id)} className="cursor-pointer text-red-500">
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </i>
                                                    </div>
                                                )}
                                            </td>
                                        </>
                                    )}
                                    {value.to_delete && (
                                        <>
                                            <td className='table-body px-1 italic'>
                                                <FontAwesomeIcon className="text-yellow-500" icon={faWarning} />&nbsp;
                                                Continue delete sub-segment?
                                            </td>
                                            <td className='table-body px-2'>
                                                <div className='flex gap-4 justify-center text-2xl items-center'>
                                                    {value.isLoading && (
                                                        <div>
                                                            <FontAwesomeIcon className="animate-spin text-xl text-blue-500" icon={faSpinner} />
                                                        </div>
                                                    )}
                                                    {!value.isLoading &&(
                                                        <div className='flex gap-4 justify-center text-2xl items-center'>
                                                            <CheckButton 
                                                                id={value.id} 
                                                                onLoad={(id, loadres)=> setLoading(id, loadres)}
                                                                toUpdate={toEditStr}
                                                                endPoint={end_point.DELETE_SUB_SEGMENT_END_POINT}
                                                                method="delete"
                                                                onSubmitStat={(id , error) => setError(id, error)}
                                                                onUpdated={(id, name) => setUpdated(id, name, 'delete')}
                                                            />
                                                            <i onClick={()=>cancelToDelete(value.id)} className="cursor-pointer text-red-500">
                                                                <FontAwesomeIcon icon={faTimes} />
                                                            </i>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </>
                                    )}
                                    {!value.editing && !value.to_delete &&(
                                        <><td className='table-body px-2'>{value.sub_segment_name}</td><td className='table-body px-2'>
                                            <div className='flex gap-4 justify-center items-center'>
                                                <i onClick={()=>setEditing(value.id)} className="cursor-pointer text-blue-500">
                                                    <FontAwesomeIcon icon={faPenToSquare} />
                                                </i>
                                                <i onClick={()=>setToDelete(value.id)} className="cursor-pointer text-red-500">
                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                </i>
                                            </div>
                                        </td></>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody className="text-center">
                            <tr className="hover:bg-gray-300">
                                <td colSpan={3} className='table-body px-2'>
                                    No sub-segment found.
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}

export default SubSegments;